import { Records as RecordsAdmin } from "@/apps/admin/router/routes";
import { Records as RecordsNormal } from "@/apps/normal/router/routes";
import { Records as RecordsApp } from "@/router/routes";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  routes: [],
});

const routes: RouteRecordRaw[] = [
  RecordsApp,
  RecordsNormal,
  RecordsAdmin,
].flat(1);

routes
  .map((route) => {
    const setRouteName = (item: RouteRecordRaw): void => {
      if (typeof item.name === "undefined" && item.path) item.name = item.path;
    };
    setRouteName(route);
    return route;
  })
  .forEach(router.addRoute);

export default router;
